
import {API_PLAYGROUND} from 'consts/api'
import {Rest} from 'utils'
import AddSample from './add-sample.vue'

export default {
  components: {
    AddSample
  },
  props: {
    datasetName: {type: String, default: undefined},
    prompt: {type: Object, default: undefined},
  },
  data(){
    return {
      rest: new Rest(),
      selected: new Set(),
      items: [],
      loading: false,
      expanded_keys: {},
      vars: {}
    }
  },
  computed: {
    dataset_active() {
      return this.items
        .filter(item => this.selected.has(item.id))
        .map(item => ({...item, status: 'ACTIVE'}))
    },
    can_add() {
      return !!Object.keys(this.vars).length
    }
  },
  watch: {
    async datasetName() {
      this.loading = true
      this.items = await this.rest.get(`${API_PLAYGROUND}/datasets/${this.datasetName}`)
      this.selected.clear()
      this.expanded_keys = {}
      this.items.forEach(item => {
        this.expanded_keys[item.id] = false
      })
      this.loading = false
    },
    prompt: {
      handler() {
        this.$debounce(this.extractVars)
      },
      deep: true
    }
  },
  methods: {
    openAddSample(){
      this.$refs.sample.open()
    },
    addSample(data){
      this.items.unshift(data)
      this.expanded_keys[data.id] = true
    },
    async remove(item){
      this.selected.delete(item.id)
      await this.rest.delete(`${API_PLAYGROUND}/datasets/items/${item.id}`)
      this.items = this.items.filter(i => i.id !== item.id)
    },
    extractVars(){
      this.vars = {}
      this.prompt.forEach(d => {
        if (d.type === 'placeholder' && d.name) {
          this.vars[d.name] = 'textarea-json'
        }
        else if (d?.content) {
          this.extractTemplateVars(d.content)
        }
      })
    },
    extractTemplateVars(text) {
      const regex = /{{\s*([\w]+)\s*}}|{%\s*if\s+([\w]+)\s*%}/g // {{ var }} | {% if var %}

      for (const match of text.matchAll(regex)) {
        const variable = match[1] || match[2]
        this.vars[variable] = 'text'
      }
    },
    toogleCheckboxes(){
      if (this.selected.size > 0) this.selected.clear()
      else this.items.forEach(item => this.selected.add(item.id)) 
    }
  }
}
